<mat-form-field appearance="fill" [formGroup]="form" class="datepicker">
    <mat-label>{{ label }}</mat-label>
    <input matInput
           [disabled]="true"
           [matDatepicker]="picker"
           [formControl]="field"
           [matDatepickerFilter]="filter"
           [required]="required">
    <mat-datepicker-toggle matSuffix
                           [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="false"></mat-datepicker>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="formValidator.isFieldInvalid(field)">{{ formValidator.setError(field) }}</mat-error>
</mat-form-field>
